export default {
  POPPINS_BLACK: 'Poppins-Black',
  POPPINS_BOLD: 'Poppins-Bold',
  POPPINS_EXTRA_BOLD: 'Poppins-ExtraBold',
  POPPINS_EXTRA_LIGHT: 'Poppins-ExtraLight',
  POPPINS_LIGHT: 'Poppins-Light',
  POPPINS_MEDIUM: 'Poppins-Medium',
  POPPINS_REGULAR: 'Poppins-Regular',
  POPPINS_SEMI_BOLD: 'Poppins-SemiBold',
  POPPINS_THIN: 'Poppins-Thin',
  HALANT:'Halant, serif',
  NUNITO_SANS:'Nunito Sans, sans-serif',
  UBUNTU:'Ubuntu, sans-serif',
  LATO: 'Lato, sans-serif',
  MONTSERRAT: 'Montserrat, sans-serif',
  MAIN_FONT: 'Ubuntu, sans-serif'

};
